export const FIND_RESULT_RATING_SUCCESS = 'FIND_RESULT_RATING_SUCCESS';

export const findResultRatingSuccess = resultRating => ({
    type: FIND_RESULT_RATING_SUCCESS,
    payload: { resultRating },
});
